import { List, styled } from '@mui/material';

export const ScrollableList = styled(List)(() => ({
  height: '100%',
  overflowX: 'hidden',
  overflowY: 'auto',
}));
